import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  disabled = false,
  onClick,
  type = 'button',
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-sofia font-medium rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 transform hover:scale-105 active:scale-95';

  const variants = {
    primary: 'bg-[#81736d] text-white hover:bg-[#81736d]/90 hover:shadow-glow focus:ring-[#81736d] shadow-medium',
    secondary: 'bg-primary text-white hover:bg-primary-light hover:shadow-medium focus:ring-primary shadow-soft',
    outline: 'border-2 border-[#81736d] text-[#81736d] hover:bg-[#81736d] hover:text-white ',
    ghost: 'text-[#81736d] hover:bg-[#81736d]/10 hover:shadow-soft focus:ring-[#81736d]',
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
    xl: 'px-8 py-4 text-xl',
  };

  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : '';

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${disabledClasses} ${className}`;

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
